import React from "react";
import Bannerheader from "../pages/Bannerheader";
import { Footer } from "../navbar/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Bannerheader />

      {/* Document Style Container */}
      <div className="bg-light py-4">
        <div className="container">
          {/* Document Paper Effect */}
          <div className="bg-white shadow rounded-3 overflow-hidden">
            {/* Document Header */}
            <div className="border-bottom p-4 p-md-5 text-center bg-primary bg-opacity-5">
              <div className="mb-3">
                <span className="bg-primary text-white px-3 py-2 rounded-3 fw-semibold small">
                  PRIVACY & DATA PROTECTION
                </span>
              </div>
              <h1 className="display-5 fw-bold text-dark mb-3">
                Privacy Policy
              </h1>
            </div>

            {/* Document Content */}
            <div className="p-4 p-md-5">
              {/* Introduction */}
              <div className="mb-5">
                <div className="bg-primary bg-opacity-5 p-4 rounded-3 border-start border-primary border-4">
                  <p className="lead text-secondary mb-0 fst-italic">
                    "Welcome to Vogelkop Architects. We value your privacy and
                    are committed to protecting your personal information. This
                    policy describes how we collect, use, and safeguard your
                    data."
                  </p>
                </div>
              </div>

              {/* Table of Contents */}
              <div className="mb-5">
                <h6 className="fw-bold mb-3 text-uppercase small text-primary">
                  Table of Contents
                </h6>
                <div className="row g-2">
                  <div className="col-md-3">
                    <a
                      href="#section1"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      1. Information We Collect
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a
                      href="#section2"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      2. How We Use Your Information
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a
                      href="#section3"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      3. Payment Security
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a
                      href="#section4"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      4. Data Protection
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a
                      href="#section5"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      5. Cookies & Tracking
                    </a>
                  </div>

                  <div className="col-md-3">
                    <a
                      href="#section7"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      6. Your Rights
                    </a>
                  </div>
                </div>
              </div>

              {/* Section 1 - Information We Collect */}
              <section id="section1" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">1</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Information We Collect</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-4">
                    We collect the following types of personal information to
                    provide and improve our services:
                  </p>

                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <div className="d-flex align-items-center p-3 border rounded-3">
                        <i className="bi bi-person-badge fs-2 text-primary me-3"></i>
                        <div>
                          <h6 className="fw-bold mb-1">Identity Information</h6>
                          <p className="small text-secondary mb-0">
                            Full name, date of birth, government ID (when
                            required)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-center p-3 border rounded-3">
                        <i className="bi bi-envelope fs-2 text-primary me-3"></i>
                        <div>
                          <h6 className="fw-bold mb-1">Contact Information</h6>
                          <p className="small text-secondary mb-0">
                            Email address, phone number, mailing address
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-center p-3 border rounded-3">
                        <i className="bi bi-credit-card fs-2 text-primary me-3"></i>
                        <div>
                          <h6 className="fw-bold mb-1">
                            Financial Information
                          </h6>
                          <p className="small text-secondary mb-0">
                            Payment details, billing address, transaction
                            history
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-center p-3 border rounded-3">
                        <i className="bi bi-truck fs-2 text-primary me-3"></i>
                        <div>
                          <h6 className="fw-bold mb-1">Shipping Information</h6>
                          <p className="small text-secondary mb-0">
                            Delivery address, shipping preferences
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-light p-4 rounded-3">
                    <h6 className="fw-bold mb-2">Additional Information:</h6>
                    <ul className="text-secondary mb-0">
                      <li>Communication preferences and marketing choices</li>
                      <li>Website usage data through cookies</li>
                      <li>Customer support interactions and feedback</li>
                      <li>Device information and IP address</li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Section 2 - How We Use Your Information */}
              <section id="section2" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">2</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">
                    How We Use Your Information
                  </h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-cart-check text-success me-2"></i>
                          <h6 className="fw-bold mb-0">Order Processing</h6>
                        </div>
                        <p className="small text-secondary mb-0">
                          To process and fulfill your orders, send
                          confirmations, and provide updates.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-headset text-success me-2"></i>
                          <h6 className="fw-bold mb-0">Customer Support</h6>
                        </div>
                        <p className="small text-secondary mb-0">
                          To respond to your inquiries, resolve issues, and
                          provide assistance.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-graph-up text-success me-2"></i>
                          <h6 className="fw-bold mb-0">Service Improvement</h6>
                        </div>
                        <p className="small text-secondary mb-0">
                          To analyze usage patterns and improve our website and
                          services.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3 h-100">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-bell text-success me-2"></i>
                          <h6 className="fw-bold mb-0">Order Updates</h6>
                        </div>
                        <p className="small text-secondary mb-0">
                          To send important notifications about your orders and
                          account.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3">
                    <div className="bg-warning bg-opacity-10 p-3 rounded-3">
                      <small className="text-warning-dark">
                        <i className="bi bi-info-circle me-2"></i>
                        Legal Basis: We process your information based on
                        contract fulfillment, legitimate business interests, and
                        your consent.
                      </small>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 3 - Payment Security */}
              <section id="section3" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">3</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Payment Security</h2>
                </div>

                <div className="ps-md-5">
                  <div className="row align-items-center">
                    <div className="col-lg-8">
                      <p className="text-secondary mb-3">
                        All payments are securely processed through{" "}
                        <strong>Razorpay</strong>, our trusted payment partner.
                        We maintain the highest security standards:
                      </p>
                      <ul className="text-secondary">
                        <li className="mb-2">
                          ✓ 256-bit SSL encryption for all transactions
                        </li>
                        <li className="mb-2">✓ PCI-DSS Level 1 compliance</li>
                        <li className="mb-2">
                          ✓ We do NOT store any card details on our servers
                        </li>
                        <li className="mb-2">
                          ✓ 3D Secure authentication for added protection
                        </li>
                        <li className="mb-2">
                          ✓ Regular security audits and penetration testing
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-4">
                      <div className="bg-light p-4 rounded-3 text-center">
                        <i className="bi bi-shield-lock fs-1 text-primary mb-2"></i>
                        <h6 className="fw-bold mb-1">PCI-DSS Compliant</h6>
                        <small className="text-secondary">
                          Level 1 Service Provider
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 4 - Data Protection */}
              <section id="section4" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">4</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Data Protection</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    We implement comprehensive security measures to protect your
                    personal information:
                  </p>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="border-start border-3 border-primary ps-3">
                        <h6 className="fw-bold mb-1">Encryption</h6>
                        <p className="small text-secondary">
                          All data encrypted in transit and at rest using
                          AES-256
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="border-start border-3 border-primary ps-3">
                        <h6 className="fw-bold mb-1">Access Control</h6>
                        <p className="small text-secondary">
                          Strict role-based access controls and authentication
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="border-start border-3 border-primary ps-3">
                        <h6 className="fw-bold mb-1">Regular Audits</h6>
                        <p className="small text-secondary">
                          Quarterly security assessments and vulnerability scans
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="border-start border-3 border-primary ps-3">
                        <h6 className="fw-bold mb-1">Data Minimization</h6>
                        <p className="small text-secondary">
                          We collect only necessary information
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 5 - Cookies & Tracking */}
              <section id="section5" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">5</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Cookies & Tracking</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    We use cookies to enhance your browsing experience:
                  </p>
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>Cookie Type</th>
                        <th>Purpose</th>
                        <th>Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Essential Cookies</td>
                        <td>Required for website functionality</td>
                        <td>Session</td>
                      </tr>
                      <tr>
                        <td>Analytics Cookies</td>
                        <td>Understand user behavior</td>
                        <td>30 days</td>
                      </tr>
                      <tr>
                        <td>Preference Cookies</td>
                        <td>Remember your settings</td>
                        <td>1 year</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              {/* Section 6 - Your Rights */}
              <section id="section7" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">6</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Your Privacy Rights</h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3">
                        <i className="bi bi-eye-fill text-primary mb-2 d-block"></i>
                        <h6 className="fw-bold">Right to Access</h6>
                        <small className="text-secondary">
                          Request a copy of your personal data
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3">
                        <i className="bi bi-pencil-fill text-primary mb-2 d-block"></i>
                        <h6 className="fw-bold">Right to Rectification</h6>
                        <small className="text-secondary">
                          Correct inaccurate information
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3">
                        <i className="bi bi-trash-fill text-primary mb-2 d-block"></i>
                        <h6 className="fw-bold">Right to Deletion</h6>
                        <small className="text-secondary">
                          Request data removal
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border rounded-3 p-3">
                        <i className="bi bi-sliders2 text-primary mb-2 d-block"></i>
                        <h6 className="fw-bold">Right to Opt-Out</h6>
                        <small className="text-secondary">
                          Unsubscribe from marketing
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Icons */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />

      {/* Custom Styles */}
      <style jsx>{`
        .bg-opacity-5 {
          background-color: rgba(var(--bs-primary-rgb), 0.05) !important;
        }
        .hover-bg-light:hover {
          background-color: #f8f9fa;
        }
      `}</style>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
